<template>
	<card title="Location">
		<div class="sk-group" v-if="hasData">
			<div class="sk-group-l">
				<!-- <div><span class="sk-value-highlight"><b>{{ data.latitude }}</b> lat / <b>{{ data.longitude }}</b> lng</span></div> -->
				<google-map-simple v-on:street="setStreet" :lat="data.location.latitude" :lng="data.location.longitude" />
			</div>
			<div class="sk-group-m">
				<div><span class="sk-value size-s">{{ street }}</span><span class="sk-title">{{ getTimePass(data.reading_time) }}</span></div>
			</div>
		</div>
		<div class="sk-group sk-group-empty" v-if="!hasData">
			<div>{{ $t('Don\'t have readings to show.') }}</div>
		</div>
		<template v-slot:more-options>
			<card-option-item-link route="WatchGeofencing" :args="{ watch_id: patient.id }" :title="$t('See More')" />
		</template>
	</card>
</template>

<script>
import CardOptionItemLink from '@/modules/common/CardOptionItemLink'
import moment from 'moment'
import { mapGetters } from 'vuex'
import Card from '@/modules/common/Card'
import GoogleMapSimple from '@/components/maps/GoogleMapSimple'
import Datetime from '@/utils/Datetime'
export default {
	name: 'card-pacient-location',
	components: {
		Card,
		GoogleMapSimple,
		CardOptionItemLink
	},
	props: {
		patient: {
			type: Object,
			default: () => ({})
		},
		datetime: {
			type: Object,
			default: () => ({
				minute: 0,
				hour: 0,
				day: 0,
				month: 0,
				year: 0
			})
		}
	},
	data() {
		return {
			type: 5,
			default: {},
			readings: [],
			street: 'unknown'
		}
	},
	computed: {
		hasData: function() {
			return this.readings.length > 0
		},
		data: function() {
			const list  = this.readings
			if (list.length === 0)
				return this.default
			const reading = list.sort((a1, a2) => a1.key - a2.key)[0]
			return reading
		},
		...mapGetters({
			getPatientByType: 'PATIENTS_READINGS_BY_TYPE'
		}),
	},
	methods: {
		setStreet: function(value) {
			this.street = value
		},
		getTimePass: (value) => moment(value).fromNow(),
		refresh() {
			this.readings = this.getPatientByType(this.patient, this.type, Datetime.toKey(this.datetime))
		}
	},
	watch: {
		datetime(newValue, oldValue) {
			this.refresh()
		}
	},
	created() {
		this.refresh()
	}
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/modules/pacient/CardPacientLocation.vue